const en = {
    meta: {
        global: {
            title: 'Boxiti',
            description: 'Boxiti'
        },
        home: {
            title: 'Logistics services',
            description: 'Looking for logistics services providers? We offer you 3PL, warehousing, order management, and delivery services. Contact us for more information.',
            h1: 'Logistics services',
            homeToUrl: 'https://boxiti.com'
        },
        pl_services: {
            title: '3PL services',
            description: '3Looking for 3PL companies? We offer you 3PL, warehousing, order management, and delivery services. Contact us for more information.',
            h1: '3PL services'
        },
        integrations: {
            title: 'Marketplace integrations',
            description: 'Want to start selling on marketplaces such as eBay, Amazon, or Shopify? Contact us and we will take care of order management and delivery.',
            h1: 'Marketplace integrations'
        },
        benefits: {
            title: '3PL benefits',
            description: 'Do you know the benefits of 3PL services? Forget order management, warehousing, and delivery problems by using our services.',
            h1: '3PL benefits'
        },
        prices: {
            title: 'Pricing',
            description: 'Check out our pricing of our 3PL, warehousing and other services and don\'t miss the best offers! Contact us for more information.',
            h1: 'Pricing'
        },
        contacts: {
            title: 'Contacts',
            description: 'Looking for logistics services providers? Contact us and we will find you the best solution for your eCommerce business!',
            h1: 'Contacts'
        },
        about: {
            title: 'About us',
            description: 'Looking for logistics services providers? We offer you 3PL, warehousing, order management, and delivery services. Contact us for more information.',
            h1: 'About us'
        },
        partners: {
            title: 'Our partners',
            description: 'Our partners – reliable companies that help us to provide you services of the highest quality. Contact us for more information.',
            h1: 'Our partners'
        },
        reviews: {
            title: 'Customer reviews',
            description: 'Do you know what others say about us? Know more about us and the quality of our services from our customers\' testimonials!',
            h1: 'Customer reviews'
        },
        blog: {
            title: 'Blog',
            description: 'Do you know everything about 3PL? Read our blog and find out about 3PL, order management, marketplace integrations, and other interesting information.',
            h1: 'Blog'
        },
        faq: {
            title: 'FAQ',
            description: 'Get answers to all our customers\' frequently asked questions. Can\'t find an answer to your question? Contact us and get help!',
            h1: 'FAQ'
        },
        privacy_policy: {
            title: 'Privacy Policy',
            description: 'Before providing your private information, read our privacy policy.',
            h1: 'Privacy Policy'
        },
        prohibited_items: {
            title: 'Prohibited items',
            description: 'Prohibited items or any item similar in description or content are strictly prohibited to ship (import,export,transport) using couriers services.',
            h1: 'Prohibited items'
        }
    }
}

const lt = {
    meta: {
        global: {
            title: 'Boxiti',
            description: 'Boxiti'
        },
        home: {
            title: 'Logistikos paslaugos',
            description: 'Domina logistikos paslaugos? Teikiame 3PL logistikos ir sandėliavimo paslaugas, vykdome užsakymus ir pasirūpiname prekių pristatymu. Susisiekite.',
            h1: 'Logistikos paslaugos ir sandėliavimo paslaugos',
            homeToUrl: 'https://boxiti.lt'
        },
        pl_services: {
            title: '3PL paslaugos',
            description: 'Reikalingos logistikos paslaugos? Teikiame 3PL logistikos ir sandėliavimo paslaugas, vykdome užsakymus ir pasirūpiname prekių pristatymu. Susisiekite.',
            h1: '3PL paslaugos'
        },
        integrations: {
            title: 'El. parduotuvių sąsaja',
            description: 'Norite prekiauti eBay, Amazon ar Shopify platformose paprasčiau? Susisiekite su mumis ir perleiskite užsakymų valdymą ir vykdymą mums.',
            h1: 'El. parduotuvių sąsaja'
        },
        benefits: {
            title: '3PL privalumai',
            description: 'Naudodamiesi kompleksinės 3PL logistikos paslaugomis galite būti ramūs – mes pasirūpinsime tiek sandėliavimu, tiek užsakymų vykdymu bei siuntų pristatymu.',
            h1: '3PL privalumai'
        },
        prices: {
            title: 'Kainos',
            description: '3PL logistikos, sandėliavimo ir kitų paslaugų kainos – susisiekite ir pasinaudokite puikiais mūsų pasiūlymais!',
            h1: 'Kainos'
        },
        contacts: {
            title: 'Kontaktai',
            description: 'Domina 3PL logistikos paslaugos? Susisiekite su mumis ir pasiūlysime Jums geriausią ir optimaliausią sprendimą el. prekybai',
            h1: 'Kontaktai'
        },
        about: {
            title: 'Apie mus',
            description: 'Domina logistikos paslaugos? Teikiame 3PL logistikos ir sandėliavimo paslaugas, vykdome užsakymus ir pasirūpiname prekių pristatymu. Susisiekite.',
            h1: 'Apie mus'
        },
        partners: {
            title: 'Mūsų partneriai',
            description: 'Mūsų partneriai – patikimos įmonės, padedančios mums suteikti kokybiškas ir operatyvias paslaugas Jums.',
            h1: 'Mūsų partneriai'
        },
        reviews: {
            title: 'Vartotojų atsiliepimai',
            description: 'Ką apie mus galvoja mūsų klientai? Sužinokite apie mus ir mūsų teikiamų paslaugų kokybę iš klientų atsiliepimų.',
            h1: 'Vartotojų atsiliepimai'
        },
        blog: {
            title: 'Blogas',
            description: 'Ar viską žinote apie 3PL logistiką? Skaitykite mūsų tinklaraštį ir sužinokite daugiau naudingos informacijos apie 3PL, el. prekybą, siuntas ir kt.',
            h1: 'Blogas'
        },
        faq: {
            title: 'DUK',
            description: 'Pateikiame atsakymus į dažniausiai klientų užduodamus klausimus. Neradote atsakymo į savo klausimą? Susisiekite.',
            h1: 'DUK'
        },
        privacy_policy: {
            title: 'Privatumo politika',
            description: 'Prieš pateikdami informaciją perskaitykite privatumo politiką.',
            h1: 'Privatumo politika'
        },
        prohibited_items: {
            title: 'Draudžiamų daiktų sąrašas',
            description: 'Draudžiamų daiktų sąraše nurodyti daiktai bei kiti panašūs į juos savo aprašymu ar turiniu yra griežtai draudžiami siųsti (įvežti, išvežti, gabenti) kurjerinėmis paslaugomis.',
            h1: 'Draudžiamų daiktų sąrašas'
        }
    }
}

export default {en, lt}



// WEBPACK FOOTER //
// ./src/i18n/meta.js